import r from '../core';

export default {
  get(options = {}, callback) {
    if ('source' in options) {
      options.url = API2_URL + 'me?source=' + options.source;
    } else {
      options.url = API2_URL + 'me';
    }
    return r.get(options, callback);
  },

  updateSettings(options = {}, callback) {
    options.url = API2_URL + 'profile';
    return r.post(options, callback);
  },

  /**
   * Upload a user profile picture.
   * If imageFile is falsely, use facebook profile instead
   * @param {File} imageFile
   * @param {Function} callback
   * @returns {Promise}
   */
  updateProfilePicture(imageFile, callback) {
    const formData = new FormData();

    const postOptions = {
      url: API2_URL + 'me/profile_image',
      params: formData,
      contentType: false,
      processData: false,
    };

    if (imageFile) {
      formData.append('image', imageFile);
    } else {
      formData.append('use_fb_profile', true);
    }

    return r.post(postOptions, callback);
  },

  sendVerificationEmail(options = {}, callback) {
    options.url = API_URL + 'send_email_verification';
    return r.post(options, callback);
  },

  login: {
    email(options = {}, callback) {
      options.url = API_URL + 'signin_email';
      return r.post(options, callback);
    },
  },

  logout(accessToken, callback) {
    return r.get({
      url: API_URL + 'logout',
    }, callback);
  },

  video: {
    getFavourites(options = {}, callback) {
      options.url = API_URL + 'me/likes';

      return r.get(options, callback);
    },

    getQueued(options = {}, callback) {
      options.url = API_URL + 'me/queue';
      return r.get(options, callback)
        // TODO: At server side, need to make this endpoint consistent with all other end point
        //       Currently this endpoint will only return an array of videos, instead of the detailed request
        .then((response) => ({
          current_page: 0,
          per_page: 10,
          total_pages: 1,
          total_videos: response.length,
          videos: response,
        }));
    },
  },

  playlist: {
    /**
     * Create a collection
     * @param {Object} collection containing the attributes needed for creation
     * @param {String} collection.listName name of the collection
     * @param {Boolean=true} collection.isPrivate
     * @return {Object} containing uid of the collection
     */
    create({ title, description, isPrivate = true }) {
      return r.post({
        url: API_URL + 'me/playlists',
        params: {
          list_name: title,
          description,
          is_private: isPrivate,
        },
      });
    },

    /**
     * Delete a collection
     * @param {String} collectionId
     * @return nothing
     */
    delete(collectionId) {
      return r.delete({
        url: API_URL + `me/playlists/${collectionId}`,
      });
    },

    /**
     * Update a collection
     * @param {Object} collection containing the updated attributes
     * @param {String} collection.title name of the collection
     * @param {Boolean=true} collection.isPrivate
     * @return the collection
     */
    update(collectionId, { title, description, isPrivate }) {
      return r.put({
        url: API_URL + `me/playlists/${collectionId}`,
        params: {
          list_name: title,
          description,
          is_private: isPrivate, // TODO test, see if server can properly handle undefined or not
        },
      });
    },

    /**
     * Update the order of videos within a collection
     * @param {String} collectionId
     * @param {Array} videos or array containing ordered object with id
     * @return {Object} this collection + videos {Array}
     */
    order(collectionId, list) {
      const idsOrder = list.map(item => item.id).join(',');
      return r.post({
        url: API_URL + `me/playlists/${collectionId}/order`,
        params: {
          ids: idsOrder,
        },
      });
    },

    video: {
      /**
       * Add a video to a collection.
       * @param {String} collectionId
       * @param {Object} video or an object containing the video uid
       * @param {String} uid video uid
       * @throws Will throw an error (400: Video already in playlist) if video has already been added
       * @throws Will throw an error (404: Object not found) if video is not found
       * @returns {Object} collection where the video is added to
       */
      add(collectionId, { uid }) {
        return r.post({
          url: API_URL + `me/playlists/${collectionId}/videos`,
          params: {
            video_id: uid,
          },
        });
      },

      /**
       * Remove a video from a collection.
       * Note: No error will be returned when removing a video that doesn't
       *       exist in the collection.
       * @param {String} collectionId
       * @param {Object} video or an object containing the video uid
       * @param {String} uid video uid
       * @throws Will throw an error (404: Object not found) if video is not found
       * @returns {Object} collection where the video is removed from
       */
      remove(colectionId, { uid }) {
        return r.delete({
          url: API_URL + `me/playlists/${colectionId}/videos/${uid}`,
        });
      },
    },
  },

  facebook: {
    getInfo(options = {}, callback) {
      options.url = API_URL + 'facebook_info';

      return r.get(options, callback);
    },
    connect(options = {}, callback) {
      options.url = API_URL + 'facebook_connect';

      return r.post(options, callback);
    },
    disconnect(options = {}, callback) {
      options.url = API_URL + 'facebook_disconnect';

      return r.post(options, callback);
    },
  },
};
